//const APIURL = "http://127.0.0.1:8000/api";
const APIURL = "https://app.mkssgsurat.in/api";
//const APIURL = "http://192.168.29.5:8000/api";

export const constants = Object.freeze({
    APIURL: APIURL
});
